import { styled } from '@mui/material';

export const HeaderContainer = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1, 2),
    backgroundColor: theme.palette.background.default,
    borderBottom: `1px solid ${theme.palette.divider}`,
    gap: theme.spacing(2),
    marginBottom: theme.spacing(1),
}));

export const EmployeeColumn = styled('div')(({ theme }) => ({
    flex: '0 0 200px', // Match PeopleListEntry EmployeeInfoContainer
    minWidth: '200px',
}));

export const ShiftsColumn = styled('div')(({ theme }) => ({
    flex: '1 1 auto', // Match PeopleListEntry ShiftsContainer
    textAlign: 'center',
}));

export const StatusColumn = styled('div')(({ theme }) => ({
    flex: '0 0 250px', // Match PeopleListEntry StatusContainer
    minWidth: '250px',
    textAlign: 'right',
}));
